export const SOURCE_TYPE = {
  0: 'eval',
  1: 'train',
  2: 'pandian',
  4: 'positionMap',
  5: 'levelMap',
  eval: 0,
  train: 1,
  pandian: 2,
  positionMap: 4,
  levelMap: 5
};

